'use strict';

app.controller('PlanningsCtrl', [
    '$scope',
    '$http',
    '$translate',
    '$ngConfirm',
    'uiGmapIsReady',
    '$stateParams',
    'toaster',
    'GoogleMapService',
    'csLanguage',
    function($scope, $http, $translate, $ngConfirm, uiGmapIsReady, $stateParams, toaster, GoogleMapService, csLanguage) {
        $scope.LIST_TAB = 1;
        $scope.PREVIEW_TAB = 2;
        $scope.tab = $scope.LIST_TAB;

        $scope.changeTab = function(v) {
            $scope.tab = v;
        };

        $scope.isTab = function(tab) {
            return $scope.tab === tab;
        };

        $scope.loading = false;
        $scope.expanded = true;

        $scope.options = {
            objects: angular.copy($scope.extractObjectsBySelectedGroup(true, false)),
        };

        $scope.form = {
            object: null,
            name: '',
            date: moment(),
            date_option: 0,
            place: null,
        };
        $scope.initialForm = angular.copy($scope.form);

        $scope.plan = {
            type: 2,
            address: null,
            points: [],
            routes: null,
        };
        $scope.initialPlanForm = angular.copy($scope.plan);

        $scope.selected = false;
        $scope.plannings = [];

        var getApplicationSettingForUser = function() {
            var endpoint = '/api/applicationSetting/client/get';

            $http.get(endpoint).then(
                function(response) {
                    $scope.isShowTrafficOnMaps = response.data.data.isShowTrafficOnMaps;
                },
                function() {
                    $scope.isShowTrafficOnMaps = false;
                }
            );
        };

        $scope.resetForms = function() {
            $scope.form = angular.copy($scope.initialForm);
            $scope.plan = angular.copy($scope.initialPlanForm);

            $scope.information = false;
        };

        $scope.resetMap = function() {
            $scope.clearMapOverlays();

            if ($scope.map.marker) {
                $scope.map.marker.setMap(null);
            }

            $scope.map.marker = new google.maps.Marker({
                map: $scope.map.object,
                anchorPoint: new google.maps.Point(0, -29),
            });
        };

        $scope.afterFormAction = function() {
            $scope.resetForms();
            $scope.cancelEditMode();
            $scope.resetMap();
            $scope.changeTab($scope.LIST_TAB);
        };

        $scope.toggleExpandedForm = function() {
            $scope.expanded = !$scope.expanded;
        };

        $scope.isExpandedForm = function() {
            return $scope.expanded === true;
        };

        var validate = function(payload, form) {
            var object = form.object || null;

            if (object === void 0 || !object === null) {
                return false;
            }

            if (!payload.routes) {
                return false;
            }

            return true;
        };

        var buildPayload = function(payload) {
            return {
                objects: [payload.object.objectId],
                routes: payload.routes,
                name: payload.object.name,
                date: payload.date,
                date_option: payload.date_option,
            };
        };

        var loadPlanningObject = function(planning) {
            $scope.form = {
                object: null,
                name: planning.name,
                date: planning.date,
                date_option: planning.date_option,
                place: null,
            };

            $scope.form.object = $scope.options.objects.find(function(value) {
                return value.objectId == planning.objects[0].id;
            });

            $scope.plan = {
                type: 2,
                address: null,
                points: [],
                routes: planning.routes,
            };

            updatePlanPoints(planning.routes.routes[0].legs);
        };

        var updatePlanPoints = function(legs) {
            $scope.plan.points = [];

            legs.map(function(o) {
                var point = {
                    address: o.start_address,
                    place_id: null,
                    coords: o.start_location.lat + ',' + o.start_location.lng,
                };

                $scope.plan.points.push(point);
            });

            var o = legs[legs.length - 1];
            var point = {
                address: o.end_address,
                place_id: null,
                coords: o.end_location.lat + ',' + o.end_location.lng,
            };

            $scope.plan.points.push(point);
        };

        /**
         * Edit mode
         */
        var editMode = false;

        $scope.edit = function(planning) {
            editMode = planning.id;

            $scope.get(planning.id).then(function(planning) {
                loadPlanningObject(planning);

                $scope.preview();
            });
        };

        $scope.isInEditMode = function(planning) {
            if (planning === void 0) {
                return editMode !== false;
            }

            return planning.id === editMode;
        };

        $scope.cancelEditMode = function() {
            $scope.resetForms();
            editMode = false;
        };

        $scope.cancel = function() {
            $scope.afterFormAction();
        };

        $scope.activation = function(planning) {
            var status = planning.status ? 0 : 1;

            apiPatchPlanning(planning.id, { status: status }).then(function() {
                planning.status = status;
            });
        };

        var apiCreatePlanning = function(data) {
            var endpoint = '/rest-api/ms/planning/api/main';

            return $http.post(endpoint, data);
        };

        var apiUpdatePlanning = function(id, data) {
            var endpoint = `/rest-api/ms/planning/api/main/${id}`;

            return $http.put(endpoint, data);
        };

        var apiPatchPlanning = function(id, data) {
            var endpoint = `/rest-api/ms/planning/api/main/${id}`;

            return $http.patch(endpoint, data);
        };

        $scope.create = function() {
            if (!validate($scope.plan, $scope.form)) {
                toaster.pop(
                    'error',
                    $translate.instant('general.toastr.error.header'),
                    $translate.instant('general.toastr.error.form.validation.fill')
                );

                return false;
            }

            var payload = Object.assign({}, $scope.form, $scope.plan);
            var data = buildPayload(payload);

            var promise = $scope.isInEditMode() ? apiUpdatePlanning(editMode, data) : apiCreatePlanning(data);

            promise.then(
                function() {
                    $scope.afterFormAction();
                    $scope.list();
                },
                function() {
                    toaster.pop(
                        'error',
                        $translate.instant('general.toastr.error.header'),
                        $translate.instant('general.toastr.error.form.action.save')
                    );
                }
            );

            return true;
        };

        $scope.sendPlanningBySMS = function() {
            var request = $scope.ngConfirmSMS;
            var id = request.planning.id;

            var endpoint = `/rest-api/ms/planning/api/google/${id}/sms?language=${csLanguage.get('lang')}`;

            return $http
                .post(endpoint, {
                    phone: request.number,
                })
                .then(function() {
                    toaster.pop(
                        'success',
                        $translate.instant('general.toastr.success.header'),
                        $translate.instant('plannings.sms.submited')
                    );
                });
        };

        $scope.preview = function() {
            $scope.changeTab($scope.PREVIEW_TAB);

            if ($scope.isShowTrafficOnMaps) {
                var trafficLayer = new google.maps.TrafficLayer();
                trafficLayer.setMap($scope.map.object);
            }

            if ($scope.plan.points.length >= 2) {
                drawPlanningRoute(true);
            }
        };

        $scope.calculateStartAddress = function() {
            var id = $scope.form.object.objectId;
            var endpoint = `/rest-api/ms/planning/api/vehicle/${id}/position`;

            $http.get(endpoint).then(function(response) {
                $scope.setStartAddress(response.data.lat, response.data.lng);
            });
        };

        $scope.setStartAddress = function(lat, lng) {
            if (!lat || !lng) {
                toaster.pop(
                    'error',
                    $translate.instant('general.toastr.error.header'),
                    $translate.instant('plannings.startAddress.error')
                );

                return;
            }

            var geocoder = new google.maps.Geocoder();
            var latlng = { lat: lat, lng: lng };

            geocoder.geocode({ location: latlng }, function(results, status) {
                $scope.plan.points[0] = {
                    address: results[0].formatted_address,
                    place_id: results[0].place_id,
                    coords: lat + ',' + lng,
                };

                if ($scope.plan.points.length >= 2) {
                    drawPlanningRoute();
                } else {
                    setLocationOnMap(latlng);
                }

                $scope.$apply();
            });
        };

        var setLocationOnMap = function(location) {
            $scope.map.object.setCenter(location);
            $scope.map.object.setZoom(7);
            $scope.map.marker.setPosition(location);
            $scope.map.marker.setVisible(true);
        };

        $scope.delete = function(id) {
            var endpoint = `/rest-api/ms/planning/api/main/${id}`;

            $http.delete(endpoint, { id: id }).then(
                function() {
                    toaster.pop(
                        'success',
                        $translate.instant('general.toastr.success.header'),
                        $translate.instant('general.toastr.success.form.action.delete')
                    );
                    $scope.list();
                },
                function() {
                    toaster.pop(
                        'error',
                        $translate.instant('general.toastr.error.header'),
                        $translate.instant('general.toastr.error.form.action.delete')
                    );
                }
            );

            return true;
        };

        $scope.list = function() {
            $scope.loading = true;
            $scope.plannings = [];

            var endpoint = '/rest-api/ms/planning/api/main';

            $http.get(endpoint).then(
                function(response) {
                    $scope.plannings = response.data;
                    $scope.loading = false;
                },
                function() {
                    $scope.loading = false;
                }
            );
        };

        $scope.get = function(id) {
            var endpoint = `/rest-api/ms/planning/api/main/${id}`;

            return $http.get(endpoint).then(function(response) {
                return response.data;
            });
        };

        $scope.init = function() {
            if (Object.getOwnPropertyNames($stateParams.object).length !== 0) {
                $scope.form.object = $scope.options.objects.find(function(value) {
                    return value.objectId == $stateParams.object.objectId;
                });

                $scope.form = {
                    object: $scope.form.object,
                    name: $scope.form.object.name,
                    date: moment(),
                    date_option: 0,
                    place: null,
                };

                $scope.tab = $scope.PREVIEW_TAB;
                $scope.setStartAddress($stateParams.object.last.y, $stateParams.object.last.x);
            } else {
                $scope.list();
            }

            getApplicationSettingForUser();
        };

        $scope.ngConfirmSMS = {
            number: null,
            planning: null,
        };

        $scope.initialNgConfirmSMS = angular.copy($scope.ngConfirmSMS);

        $scope.smsConfirmation = function(planning) {
            $scope.ngConfirmSMS = angular.copy($scope.initialNgConfirmSMS);
            $scope.ngConfirmSMS.planning = planning;

            $ngConfirm({
                title: $translate.instant('plannings.sms.title') + ' - <b>' + planning.name + '</b>',
                contentUrl: 'tpl/pages/plannings/modals/sms.html',
                animation: 'rotate',
                theme: 'supervan',
                columnClass: 'medium',
                icon: 'pe-7s-phone pe-lg pe-va',
                scope: $scope,
                buttons: {
                    yes: {
                        text: $translate.instant('plannings.sms.submit'),
                        btnClass: 'btn-success',
                        action: function(scope) {
                            scope.sendPlanningBySMS();

                            return true;
                        },
                    },
                    no: {
                        text: $translate.instant('plannings.sms.cancel'),
                        btnClass: 'btn-dark',
                    },
                },
            });
        };

        $scope.deleteConfirmation = function(planning) {
            var name = planning.name;

            $ngConfirm({
                title: $translate.instant('general.confirm.delete.title'),
                content: $translate.instant('general.confirm.delete.content') + '<b> (' + name + ') </b>',
                animation: 'rotate',
                theme: 'supervan',
                columnClass: 'medium',
                icon: 'pe-7s-trash pe-lg pe-va',
                scope: $scope,
                buttons: {
                    yes: {
                        text: $translate.instant('general.confirm.delete.yes'),
                        btnClass: 'btn-danger',
                        action: function(scope) {
                            scope.delete(planning.id);

                            return true;
                        },
                    },
                    no: {
                        text: $translate.instant('general.confirm.delete.no'),
                        btnClass: 'btn-dark',
                    },
                },
            });
        };

        $scope.onPlanningPointsOrderChange = function() {
            drawPlanningRoute();
        };

        $scope.addPlanningPoint = function() {
            if (!$scope.place || $scope.plan.address === '') {
                return false;
            }

            var point = {
                address: $scope.plan.address,
                place_id: $scope.place.place_id,
                coords: $scope.place.geometry.location.lat() + ',' + $scope.place.geometry.location.lng(),
            };

            $scope.plan.points.push(point);
            $scope.plan.address = '';

            if ($scope.plan.points.length >= 2) {
                $scope.map.marker.setPosition(null);
                drawPlanningRoute();
            }
        };

        var findPlaceAndAddToPlan = function(request) {
            var placeService = new google.maps.places.PlacesService($scope.map.object);

            placeService.findPlaceFromQuery(request, function(results) {
                if (!results || results.length === 0) {
                    toaster.pop(
                        'error',
                        $translate.instant('general.toastr.error.header'),
                        $translate.instant('plannings.autocomplete.unreachable')
                    );

                    $scope.$apply();

                    return;
                }

                var place = results[0];

                $scope.place = null;
                $scope.place = place;

                $scope.addPlanningPoint();
            });
        };

        $scope.addPlanningPointButton = function() {
            var request = {
                query: $scope.plan.address,
                fields: ['place_id', 'geometry'],
            };

            findPlaceAndAddToPlan(request);
        };

        $scope.removePlanningPoint = function(key) {
            if ($scope.plan.points[key] !== void 0) {
                $scope.plan.points.splice(key, 1);
                drawPlanningRoute();
            }
        };

        /**
         * Map settings
         */
        $scope.map = GoogleMapService.defaults();

        $scope.clearMapOverlays = function() {
            for (var i = 0; i < $scope.map.overlays.length; i++) {
                $scope.map.overlays[i].setMap(null);
            }

            $scope.map.overlays = [];
        };

        /**
         * Information section
         */
        $scope.information = false;
        $scope.areInformationAvailable = function() {
            return $scope.information !== false;
        };

        var getOverallInformation = function() {
            var duration = 0;
            var distance = 0;
            var route = $scope.plan.routes.routes[0];

            for (var i in route.legs) {
                duration += route.legs[i].duration.value;
                distance += route.legs[i].distance.value;
            }

            $scope.information = {
                time: {
                    text: moment.utc(duration * 1000).format('HH:mm'),
                    value: duration,
                },
                distance: {
                    text: Math.round(distance / 1000),
                    value: distance,
                },
            };
        };

        var drawPlanningRoute = function(dataset) {
            var set = dataset !== void 0;

            $scope.clearMapOverlays();
            !set && ($scope.plan.routes = null);

            var points = $scope.plan.points.slice();

            if (points.length < 2) {
                return false;
            }

            var origin = points.shift();
            var destination = points.pop();

            var waypoints = points.map(function(o) {
                return { location: o.coords };
            });

            var directionsDisplay = new google.maps.DirectionsRenderer({
                draggable: true,
            });

            /**
             * Draggable event for change route in the fly
             * Update all routes data
             */
            directionsDisplay.addListener('directions_changed', function() {
                var updated = directionsDisplay.getDirections();

                if (updated.status === 'OK' && $scope.plan.routes.geocoded_waypoints !== updated.geocoded_waypoints) {
                    $scope.plan.routes = updated;
                    updatePlanPoints(updated.routes[0].legs);
                    getOverallInformation();

                    $scope.$apply();
                }
            });

            var request = {
                origin: origin.coords,
                destination: destination.coords,
                waypoints: waypoints,
                travelMode: google.maps.DirectionsTravelMode.DRIVING,
            };

            if (set) {
                request = $scope.plan.routes.request;
            }

            uiGmapIsReady.promise().then(function() {
                $scope.map.object = $scope.map.control.getGMap();
                $scope.resetMap();
                $scope.directionsService = new google.maps.DirectionsService();

                directionsDisplay.setMap($scope.map.object);
                $scope.map.overlays.push(directionsDisplay);

                $scope.directionsService.route(request, function(result, status) {
                    if (status === 'OK') {
                        $scope.plan.routes = result;

                        getOverallInformation();
                        directionsDisplay.setDirections(result);
                    }
                });
            });
        };

        $scope.showAddPointButton = function() {
            return $scope.plan.points.length >= 2;
        };

        var initSearchBox = function() {
            var searchbox = document.getElementById('searchbox-input');
            var googleSearchBox = new google.maps.places.SearchBox(searchbox, {});

            googleSearchBox.addListener('places_changed', function() {
                var places = googleSearchBox.getPlaces();
                if (!places || places.length === 0) {
                    toaster.pop(
                        'error',
                        $translate.instant('general.toastr.error.header'),
                        $translate.instant('plannings.autocomplete.unreachable')
                    );

                    $scope.$apply();

                    return;
                }

                var place = places[0];

                $scope.place = null;
                $scope.place = place;

                $scope.addPlanningPoint();
            });
        };

        var initClickOnMap = function() {
            $scope.map.object.addListener('click', function(e) {
                var geocoder = new google.maps.Geocoder();

                geocoder.geocode({ location: e.latLng }, function(results, status) {
                    var point = {
                        address: results[0].formatted_address,
                        place_id: results[0].place_id,
                        coords: e.latLng.lat() + ',' + e.latLng.lng(),
                    };

                    $scope.plan.points.push(point);

                    if ($scope.plan.points.length >= 2) {
                        $scope.map.marker.setPosition(null);

                        drawPlanningRoute();
                    } else {
                        setLocationOnMap(e.latLng);
                    }

                    $scope.$apply();
                });
            });

            $scope.map.object.setOptions({ draggableCursor: 'crosshair' });
        };

        $scope.gMapPromise = function() {
            uiGmapIsReady.promise().then(function() {
                $scope.map.object = $scope.map.control.getGMap();
                $scope.resetMap();
                $scope.directionsService = new google.maps.DirectionsService();

                initSearchBox();
                initClickOnMap();
            });
        };

        $scope.init();
        $scope.gMapPromise();
    },
]);
